import { render, staticRenderFns } from "./LeftArea.vue?vue&type=template&id=0983d844&"
import script from "./LeftArea.vue?vue&type=script&lang=js&"
export * from "./LeftArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports